import React from 'react';
import 'bootstrap/dist/css/bootstrap.css';

const Footer = () => {
  return (
    <footer>
      <p className="text-center mb-0">
        &copy; {new Date().getFullYear()} RK Water Operations, LLC
      </p>
    </footer>
  );
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/common/Footer.js